import {
  ScrollView,
  StyleSheet,
  Switch,
  Text,
  TouchableOpacity,
  View,
} from 'react-native'
import {LinearGradient} from 'expo-linear-gradient'

import {type ThemeEditorProps} from '#/types/capsule'
import {GRADIENT_PRESETS, type GradientPreset} from './settingsSchema'

const PRESET_LABELS: Record<GradientPreset, string> = {
  aurora: 'Aurora',
  sunset: 'Sunset',
  ocean: 'Ocean',
  forest: 'Forest',
  rose: 'Rose',
  night: 'Night',
}

export function EditorComponent({capsule, onSettingsUpdate}: ThemeEditorProps) {
  const s = capsule.behaviorSettings
  const preset = (s.gradientPreset as GradientPreset) ?? 'aurora'
  const instant = s.instantFeedback !== false
  const progress = s.showProgressBar !== false
  const timer = s.showTimer === true

  return (
    <ScrollView
      contentContainerStyle={styles.root}
      showsVerticalScrollIndicator={false}>
      <Text style={styles.sectionTitle}>🎨 Thème Liquid Glass</Text>

      <Text style={styles.label}>Dégradé de fond</Text>
      <View style={styles.presetRow}>
        {(Object.keys(GRADIENT_PRESETS) as GradientPreset[]).map(key => (
          <TouchableOpacity
            accessibilityRole="button"
            key={key}
            onPress={() => onSettingsUpdate({...s, gradientPreset: key})}
            style={[
              styles.presetPill,
              preset === key && styles.presetPillActive,
            ]}>
            <LinearGradient
              colors={
                GRADIENT_PRESETS[key] as readonly [string, string, ...string[]]
              }
              start={{x: 0, y: 0}}
              end={{x: 1, y: 1}}
              style={styles.presetGrad}
            />
            <Text
              style={[styles.presetLabel, preset === key && {color: '#fff'}]}>
              {PRESET_LABELS[key]}
            </Text>
          </TouchableOpacity>
        ))}
      </View>

      {[
        {label: 'Feedback instantané', key: 'instantFeedback', val: instant},
        {label: 'Barre de progression', key: 'showProgressBar', val: progress},
        {label: 'Minuteur', key: 'showTimer', val: timer},
      ].map(({label, key, val}) => (
        <View key={key} style={styles.row}>
          <Text style={styles.rowLabel}>{label}</Text>
          <Switch
            value={val}
            onValueChange={v => onSettingsUpdate({...s, [key]: v})}
            trackColor={{true: '#a855f7'}}
          />
        </View>
      ))}
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  root: {padding: 20, gap: 14},
  sectionTitle: {
    color: '#fff',
    fontSize: 18,
    fontWeight: '800',
    marginBottom: 4,
  },
  label: {
    color: 'rgba(255,255,255,0.7)',
    fontSize: 12,
    fontWeight: '700',
    letterSpacing: 1,
  },
  presetRow: {flexDirection: 'row', flexWrap: 'wrap', gap: 10},
  presetPill: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    backgroundColor: 'rgba(255,255,255,0.06)',
    borderRadius: 24,
    paddingVertical: 8,
    paddingHorizontal: 14,
    borderWidth: 1.5,
    borderColor: 'transparent',
  },
  presetPillActive: {
    borderColor: '#a855f7',
    backgroundColor: 'rgba(168,85,247,0.15)',
  },
  presetGrad: {width: 20, height: 20, borderRadius: 10},
  presetLabel: {
    color: 'rgba(255,255,255,0.5)',
    fontSize: 13,
    fontWeight: '600',
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: 'rgba(255,255,255,0.06)',
    borderRadius: 14,
    padding: 14,
  },
  rowLabel: {color: '#fff', fontSize: 14, fontWeight: '600'},
})
